import 'ol/ol.css';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature';
import DrawFunctions from '../helpers/DrawFunctions';
import proj4 from 'proj4';
import LineString from 'ol/geom/LineString';
import FeatureStyle from '../helpers/FeatureStyles';
import MapElement from './MapElement';



export default class MapDiagnosticsMachine extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection) {
        var sourceproj = new proj4.Proj(projection);
        var destproj = new proj4.Proj(this.mapModel.projection);

        var machineLocation = proj4.transform(sourceproj, destproj, [data.CorGPSX, data.CorGPSY]);

        const machinePoint = new Point([machineLocation.x, machineLocation.y]);

        let machineFeature = new Feature(machinePoint);
        machineFeature.set('type', 'machine');
        machineFeature.set('heading', data.Heading2Atan2);


        var machineFeatures = [machineFeature];

        if (data.MachineLine1) {
            var linepoints1 = [];
            data.MachineLine1.forEach(coordinates => {
                let result = DrawFunctions.RotateCoordinates(coordinates.x, coordinates.y, data.Heading2Atan2);

                linepoints1.push([result.x + machineLocation.x, result.y + machineLocation.y]);
            });

            let line1 = new LineString(linepoints1);
            let line1feature = new Feature(line1);
            line1feature.set('type', 'machineLine');
            machineFeatures.push(line1feature);

            var linepoints2 = [];
            data.MachineLine2.forEach(coordinates => {
                let result = DrawFunctions.RotateCoordinates(coordinates.x, coordinates.y, data.Heading2Atan2);

                linepoints2.push([result.x + machineLocation.x, result.y + machineLocation.y]);
            });

            let line2 = new LineString(linepoints2);
            let line2feature = new Feature(line2);
            line2feature.set('type', 'machineLine');
            machineFeatures.push(line2feature);
        }

        const machineSource = new VectorSource({ features: machineFeatures });

        var style = (ft, res) => {
            return FeatureStyle.customDiagnosticsStyle(ft, res, this.mapModel.dark);
        };

        this.layer = new VectorLayer({
            source: machineSource,
            style: style
        });

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}